import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Carousel from 'react-bootstrap/Carousel';
import DownArrow from '../../svgs/downarrow.svg';
import { ProductTile } from '../common/ProductTile';
import { ProductTileModel } from '../../models/globals';
import { chunkArray } from '../../utilities/ArrayUtilities';
import { Responsive, ResponsiveProps } from '../common/Responsive';

interface ProductsCarouselProps {
    products: ProductTileModel[];
    productsPerPage: number;
    viewMode: ResponsiveProps['viewMode'];
    testIdSuffix: string;
}

const ProductsCarousel: React.FC<ProductsCarouselProps> = ({ products, productsPerPage, viewMode, testIdSuffix }) => {
    const pages: ProductTileModel[][] = chunkArray(products, productsPerPage);
    return (
        <Responsive viewMode={viewMode} testIdSuffix={testIdSuffix}>
            <Carousel
                controls={pages.length > 1}
                indicators={false}
                interval={null}
                nextIcon={<DownArrow aria-hidden="true" className="arrow-next text-dark" />}
                prevIcon={<DownArrow aria-hidden="true" className="arrow-prev text-dark" />}
                wrap={false}
            >
                {pages.map((pageProducts) => {
                    return (
                        <Carousel.Item key={pageProducts[0].detailPageUrl.url}>
                            <Row className="px-5">
                                {Array.from({ length: productsPerPage }, (_, i) => {
                                    const product = pageProducts[i];
                                    return (
                                        <Col key={product?.detailPageUrl.url ?? i}>
                                            {product && <ProductTile product={product} {...product} index={i} />}
                                        </Col>
                                    );
                                })}
                            </Row>
                        </Carousel.Item>
                    );
                })}
            </Carousel>
        </Responsive>
    );
};

export { ProductsCarousel };
